export const BASE_PATH = "/help-support";

export const routes = {
  home: () => BASE_PATH,
  search: (searchTerm) =>
    `${BASE_PATH}/search?term=${encodeURIComponent(searchTerm)}`,
  category: (category: string): string => `${BASE_PATH}/${category}`,
  subcategory: (category: string, subcategory: string): string =>
    `${BASE_PATH}/${category}/${subcategory}`,
  article: (category: string, subcategory: string, article: string): string =>
    `${BASE_PATH}/${category}/${subcategory}/${article}`,
};
